module.exports = __webpack_public_path__ + "static/media/icon_trash-failed.11ca6b62.svg";